/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateRequestSingleNoteRequest } from '../models/CreateRequestSingleNoteRequest';
import type { CreateRequestSingleNoteResponse } from '../models/CreateRequestSingleNoteResponse';
import type { UpdateRequestSingleNoteRequest } from '../models/UpdateRequestSingleNoteRequest';
import type { UpdateRequestSingleNoteResponse } from '../models/UpdateRequestSingleNoteResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class TravelRequestControllerV2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestId
     * @param requestBody
     * @returns CreateRequestSingleNoteResponse
     * @throws ApiError
     */
    public travelRequestControllerV2CreateRequestSingleNote(
        requestId: number,
        requestBody: CreateRequestSingleNoteRequest,
    ): Observable<CreateRequestSingleNoteResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/requests/travel/{requestId}/note',
            path: {
                'requestId': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestId
     * @param noteId
     * @param requestBody
     * @returns UpdateRequestSingleNoteResponse
     * @throws ApiError
     */
    public travelRequestControllerV2UpdateRequestSingleNote(
        requestId: number,
        noteId: number,
        requestBody: UpdateRequestSingleNoteRequest,
    ): Observable<UpdateRequestSingleNoteResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/requests/travel/{requestId}/note/{noteId}',
            path: {
                'requestId': requestId,
                'noteId': noteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestId
     * @param noteId
     * @returns binary
     * @throws ApiError
     */
    public travelRequestControllerV2DeleteRequestSingleNote(
        requestId: number,
        noteId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/v2/requests/travel/{requestId}/note/{noteId}',
            path: {
                'requestId': requestId,
                'noteId': noteId,
            },
        });
    }
}
